import { useEffect, useState, useCallback } from "react"
import { PurchasProvider, usePurchase } from "../../context/purchaseContext"
import { ExpirationProvider } from "../../context/expirationContext"
import { UltimateAlertsProvider } from "../../context/ultimateAlertsContext"
import { useAppState } from "../../context/appStateContext"
import useQueryParams from "../../hooks/useQueryParams"
import useLastExpiredWasUltimate from "../../hooks/useLastExpiredWasUltimate"
import TwoStepPaywall from "../TwoStepPaywall/TwoStepPaywall"
import ExpirationStep1 from "./ExpirationStep1/ExpirationStep1"
import ExpirationStep2 from "./ExpirationStep2/ExpirationStep2"
import LifetimeBottomSheet from "./LifetimeBottomSheet/LifetimeBottomSheet"
import LifetimeComingSoonPopup from "./LifetimeComingSoonPopup/LifetimeComingSoonPopup"
import ComparePlansSheet from "../../components/ComparePlansSheet/ComparePlansSheet"
import UltimateSubfeaturesPopups from "../../components/UltimateSubfeaturesPopups/UltimateSubfeaturesPopups"
import native from "../../native/native"
import styles from "./BubbleExpirationPaywall.module.scss"

const BubbleExpirationPaywall = () => {
  return (
    <PurchasProvider>
      <UltimateAlertsProvider>
        <BubbleExpirationContent />
      </UltimateAlertsProvider>
    </PurchasProvider>
  )
}

const BubbleExpirationContent = () => {
  const { actions } = useAppState()
  const purchaseActions = usePurchase().actions
  const { showLifetimeSecondStep } = useQueryParams()
  const lastExpiredSubscriptionWasUltimate = useLastExpiredWasUltimate()
  const [showLifetimeSheet, setShowLifetimeSheet] = useState(false)
  const [showLifetimePopup, setShowLifetimePopup] = useState(false)

  useEffect(() => {
    actions.setHeaderInsetColor("var(--background)")
    actions.setIgnoreFooterInset(true)

    if (lastExpiredSubscriptionWasUltimate) {
      purchaseActions.setUltimateSelected(true)
    }
  }, [actions])

  const handleLifetimeClick = useCallback(() => {
    if (showLifetimeSecondStep) {
      setShowLifetimeSheet(true)
    } else {
      setShowLifetimePopup(true)
    }
  }, [])

  const handleSheetClose = useCallback(() => {
    setShowLifetimeSheet(false)
  }, [])

  const handleSheetCta = useCallback(() => {
    native.logMixpanelEvent("html_lifetime_sheet_cta")
    setShowLifetimePopup(true)
  }, [])

  const handlePopupClose = useCallback(() => {
    setShowLifetimePopup(false)
  }, [])

  return (
    <div className={styles.container}>
      <TwoStepPaywall
        MainPage={<ExpirationStep2 onLifetimeClick={handleLifetimeClick} />}
        WarmupPage={<ExpirationStep1 onLifetimeClick={handleLifetimeClick} />}
        disableFullScreen
      />
      <LifetimeComingSoonPopup
        visible={showLifetimePopup}
        onClose={handlePopupClose}
      />
      <LifetimeBottomSheet
        visible={showLifetimeSheet}
        onClose={handleSheetClose}
        onCtaClick={handleSheetCta}
      />
      <ComparePlansSheet />
      <UltimateSubfeaturesPopups />
    </div>
  )
}

export default BubbleExpirationPaywall
